export class Dom {
  static getTarget(el, selector) {
    return el.matches(selector) ? el : el.closest(selector);
  }
}
